import { render, staticRenderFns } from "./ProjectMember.vue?vue&type=template&id=afa42334"
import script from "./ProjectMember.vue?vue&type=script&lang=js"
export * from "./ProjectMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports